import React from "react";

const alignClass = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

function DataTable({
  columns,
  rows,
  rowKey,
  loading = false,
  emptyMessage = "No records found.",
  minWidth = "640px",
  footer = null,
}) {
  const visibleRows = Array.isArray(rows) ? rows : [];
  const columnCount = columns.length;

  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
      <div className="w-full overflow-x-auto">
        <table className="w-full table-auto" style={{ minWidth }}>
          <thead className="bg-slate-50">
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={`border-b border-slate-200 px-5 py-5 text-sm font-semibold text-slate-700 ${
                    alignClass[column.align] ?? alignClass.left
                  } ${column.headerClassName ?? ""}`}
                  style={{ width: column.width }}
                >
                  {column.header ?? column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={columnCount}
                  className="px-5 py-10 text-center text-sm text-slate-500"
                >
                  Loading...
                </td>
              </tr>
            ) : visibleRows.length === 0 ? (
              <tr>
                <td
                  colSpan={columnCount}
                  className="px-5 py-10 text-center text-sm text-slate-500"
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              visibleRows.map((row, index) => (
                <tr
                  key={typeof rowKey === "function" ? rowKey(row) : row[rowKey]}
                  className="border-b border-slate-100 last:border-b-0"
                >
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      className={`px-5 py-5 align-middle text-sm text-slate-800 ${
                        alignClass[column.align] ?? alignClass.left
                      } ${column.className ?? ""}`}
                    >
                      {column.render ? column.render(row, index) : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {footer}
    </div>
  );
}

export default DataTable;
